import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ light = false, compact = false, size = 64 }) => {
  const textColor = light ? "text-white" : "text-[#0A1A2F]";
  const subColor = light ? "text-white/70" : "text-[#6B7280]";
  return (
    <Link to="/" data-testid="eyb-logo" className="inline-flex items-center gap-3 group">
      <img
        src="/eyb-logo.png"
        alt="EYB Consulting"
        style={{ height: size, width: size }}
        className="object-contain"
      />
      {!compact && (
        <div className="flex flex-col leading-tight">
          <span className={`font-display font-bold text-[18px] tracking-tight ${textColor}`}>
            EYB Consulting
          </span>
          <span className={`text-[11px] mt-1 ${subColor}`}>
            Clarity and Control, Built for Your Business
          </span>
        </div>
      )}
    </Link>
  );
};
